var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.492,
    height: 26.492,
    viewBox: "0 0 26.492 26.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6da544;}.b{fill:#ffda44;}.c{fill:#d80027;}.d{fill:#f0f0f0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.668,155.062a13.294,13.294,0,0,0,0-9.215L13.246,144.7.824,145.848a13.294,13.294,0,0,0,0,9.215l12.422,1.152Z",
    transform: "translate(0 -137.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.767,8.639a13.251,13.251,0,0,0-24.844,0Z",
    transform: "translate(-15.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M28.345,353.682a13.251,13.251,0,0,0,12.422-8.639H15.923A13.251,13.251,0,0,0,28.345,353.682Z",
    transform: "translate(-15.099 -327.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M98.618,95.642H91.679l-2.144-6.6-2.144,6.6H80.451l5.614,4.079-2.144,6.6,5.614-4.031,5.614,4.031L93,99.721Z",
    transform: "translate(-76.288 -84.436)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/my.7b13c4ec1c03c01aeaf966ebb83e1179.svg";
export { ForwardRef as ReactComponent };